/**
 * Provides a stable callback to refetch balance after a chat stream completes.
 * Intended to be passed as onConversationComplete to useStreamCallbacks.
 */

import { useCallback } from 'react'

import { useLedgerApi } from './use-ledger-api.hook'

export const useBalanceRefreshOnStream = (): (() => void) => {
  const { refetchBalance } = useLedgerApi()

  return useCallback(() => {
    void refetchBalance()
  }, [refetchBalance])
}
